export default (isSmoothScroll?: boolean): void => {
  if (typeof window !== 'undefined') {
    window.scrollTo({
      top: 0,
      behavior: isSmoothScroll ? 'smooth' : 'instant',
    })
  }
}
